import { createAction } from 'redux-actions';
import { ProfileOwnerStats } from './../../types/profileOwner';

export const FETCH_PROFILE_OWNER_SUCCESS = 'FETCH.PROFILE_OWNER.SUCCESS';
export const FETCH_PROFILE_OWNER_TAGLINE_SUCCESS =
  'FETCH.PROFILE_OWNER_TAGLINE.SUCCESS';
export const FETCH_PROFILE_OWNER_STATS_SUCCESS =
  'FETCH.PROFILE_OWNER_STATS.SUCCESS';
export const FETCH_PROFILE_OWNER_GIVE_STATE = 'FETCH.PROFILE_OWNER_GIVE_STATE';
export const FETCH_PROFILE_OWNER_GIVE_STATE_SUCCESS =
  'FETCH.PROFILE_OWNER_GIVE_STATE.SUCCESS';
export const FETCH_PROFILE_OWNER_GIVE_STATE_FAILURE =
  'FETCH.PROFILE_OWNER_GIVE_STATE.FAILURE';

export type FetchProfileOwnerSuccessPayload = {
  user: { id: number };
  entities: any;
  isWatching: boolean;
  stats: ProfileOwnerStats;
  tagline?: string;
};

export type FetchProfileOwnerTaglinePayload = {
  tagline?: string;
};

// those stats that are got from standalone modules, not from 'userstats' module
export type FetchProfileOwnerStatsPayload = Pick<
  ProfileOwnerStats,
  'badgesSent' | 'badgesReceived' | 'groupsAdmin' | 'groupsMember'
>;

export type FetchProfileOwnerGiveStatePayload = {
  canBeGivenLlama?: boolean;
  canBeGivenCake?: boolean;
  canBeGivenCore?: boolean;
  isLoading?: boolean;
};

export const fetchProfileOwnerSuccess = createAction<
  FetchProfileOwnerSuccessPayload
>(FETCH_PROFILE_OWNER_SUCCESS);

export const fetchProfileOwnerTaglineSuccess = createAction<
  FetchProfileOwnerTaglinePayload
>(FETCH_PROFILE_OWNER_TAGLINE_SUCCESS);

export const fetchProfileOwnerStatsSuccess = createAction<
  FetchProfileOwnerStatsPayload
>(FETCH_PROFILE_OWNER_STATS_SUCCESS);

export const fetchProfileOwnerGiveState = createAction(
  FETCH_PROFILE_OWNER_GIVE_STATE
);

export const fetchProfileOwnerGiveStateSuccess = createAction<
  FetchProfileOwnerGiveStatePayload
>(FETCH_PROFILE_OWNER_GIVE_STATE_SUCCESS);

export const fetchProfileOwnerGiveStateFailure = createAction(
  FETCH_PROFILE_OWNER_GIVE_STATE_FAILURE
);
